/* eslint-disable no-useless-return */
import { FC, useEffect, useRef, useState } from 'react';
import { Tooltip } from 'common-components';
import { Tag } from './contentCardTypes';
import styles from './links.module.scss';

const Links: FC<{ links: Tag[]; width: string }> = ({ links, width }: { links: Tag[]; width: string }) => {
    const parentRef = useRef<HTMLDivElement>(null);
    const [renderedItems, setRenderedItems] = useState<JSX.Element[]>([]);

    const getItemWidth = (item: string) => {
        const a = document.createElement('a');
        a.innerText = item;
        a.style.position = 'absolute';
        a.style.fontFamily = 'inter';
        a.style.visibility = 'hidden';
        document.body.appendChild(a);
        const width = a.offsetWidth;
        document.body.removeChild(a);
        return width;
    };
    const handleResize = () => {
        if (parentRef.current) {
            let totalWidth = 0;
            const renderedItems: JSX.Element[] = [];
            links.forEach((link, index) => {
                const itemWidth = getItemWidth(link.tag);
                const marginWidth = 8;
                const remainingCountWidth = getItemWidth(` + ${links.length - (renderedItems.length + 1)}`);
                const totalItemWidth = itemWidth;
                if (totalWidth + totalItemWidth + marginWidth + remainingCountWidth <= parentRef.current!.offsetWidth) {
                    renderedItems.push(
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <a href={link.url}>{link.tag}</a>
                        </div>
                    );
                    totalWidth += totalItemWidth + marginWidth;
                } else {
                    return;
                }
            });
            if (renderedItems.length < links.length) {
                if (renderedItems.length === 0) {
                    renderedItems.push(
                        <div
                            key={1}
                            style={{
                                gap: '5px'
                            }}
                        >
                            <a
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: parentRef.current.clientWidth - 50,
                                    display: 'inline-block',
                                    textOverflow: 'ellipsis'
                                }}
                                href={links[0].url}
                            >
                                {links[0].tag}
                            </a>
                        </div>
                    );
                }
                if (renderedItems.length < links.length) {
                    renderedItems.push(
                        <div>
                            <Tooltip
                                type="primary"
                                title={
                                    <div className={styles['links-tooltip-wrapper']}>
                                        {links.slice(renderedItems.length).map(link => (
                                            <a href={link.url} key={link.tag}>
                                                {link.tag}
                                            </a>
                                        ))}
                                    </div>
                                }
                            >
                                <div
                                    key="remaining"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        gap: '5px',
                                        width: 'auto'
                                    }}
                                    className={styles.more}
                                >
                                    + {links.length - renderedItems.length}
                                </div>
                            </Tooltip>
                        </div>
                    );
                }
            }
            setRenderedItems(renderedItems);
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [width, links]);

    return (
        <div style={{ display: 'flex', width }} ref={parentRef} className={styles['links-wrapper']}>
            {renderedItems.map((item, index) => (
                <>
                    {item}
                    {renderedItems.length - 1 === index ? null : <hr />}
                </>
            ))}
        </div>
    );
};

export default Links;
